import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAPVHiqKFm9tEDSK60qbpKIJrnCtkquHLs",
  authDomain: "itconsults-co.firebaseapp.com",
  projectId: "itconsults-co",
  storageBucket: "itconsults-co.firebasestorage.app",
  messagingSenderId: "464389114923",
  appId: "1:464389114923:web:dc5678cb7d2b4f3b3b2e6e",
  measurementId: "G-XRPK0QT79B",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export default app;
